import { render, staticRenderFns } from "./Show-campaign.vue?vue&type=template&id=9a27efc6&"
import script from "./Show-campaign.vue?vue&type=script&lang=js&"
export * from "./Show-campaign.vue?vue&type=script&lang=js&"
import style0 from "./Show-campaign.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports